module.exports = __webpack_public_path__ + "stylesheets/relation-list_a979ecfb185e9e98e2f99bd892cfc28b.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/relation-list.less
// module id = hVBH
// module chunks = 154